// VEC-3570: regla única de entrada para la CANTIDAD del presupuesto detallado.
//
// La cantidad admite hasta 2 decimales (ej: 12.75) en las tres variantes del presupuesto detallado:
// ítem Repuesto/Producto, ítem Mano de Obra y Mano de Obra cargada como Tarea. Antes cada componente
// repetía el mismo par regex + onKeyDown con 1 solo decimal (VEC-3532 / VEC-3556), lo que hacía que
// ampliar la escala implicara tocar tres archivos y quedar expuestos a que uno se olvidara.
//
// El tope de 2 decimales acompaña a la columna `decimal(13,2)` de `presupuesto_items.cantidad` y
// `presupuesto_tareas.cantidad`: un tercer decimal lo redondearía MySQL en el INSERT, así que se corta
// en el input para que lo que el usuario ve sea lo que se persiste.

export const CANTIDAD_MAX_DECIMALES = 2;

// step declarado en el input, alineado con los 2 decimales.
export const CANTIDAD_STEP = '0.01';

// Dígitos + (punto + hasta 2 decimales) opcional. Todo lo que sobra se descarta.
const CANTIDAD_REGEX = /^\d*(?:\.\d{0,2})?/;

// Recorta el valor tipeado/pegado al formato admitido. Nunca devuelve null: si no matchea nada
// (string vacío) devuelve '' para que el input quede controlado igual.
export const recortarCantidad = (value) => {
	const m = String(value === null || value === undefined ? '' : value).match(CANTIDAD_REGEX);
	return m ? m[0] : '';
};

// onKeyDown compartido: bloquea notación científica, signos y coma (el separador es el punto), y
// permite un único punto decimal por valor.
export const bloquearTeclaCantidad = (e) => {
	if (['e', 'E', '+', '-', ','].indexOf(e.key) !== -1) {
		e.preventDefault();
		return;
	}
	if (e.key === '.' && String(e.target.value).indexOf('.') !== -1) {
		e.preventDefault();
	}
};
